import { motion } from 'framer-motion';

const SecurityInfo = () => {
  return (
    <motion.div 
      layout
      transition={{
        layout: { type: "spring", stiffness: 300, damping: 30 }
      }}
      className="mb-6 bg-[#f8f5f2] border border-[#e2dad3] rounded-xl p-4"
    >
      <div className="flex items-start">
        <div className="mr-3 text-[#694e42] flex-shrink-0 mt-0.5">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div>
          <h4 className="font-medium text-sm text-[#694e42] mb-1">Your security is our priority</h4>
          <p className="text-xs text-[#8a7266]">Your email credentials are securely encrypted and never stored on our servers. We use industry-standard OAuth protocols to ensure your data remains protected.</p>
        </div>
      </div>
    </motion.div>
  );
};

export default SecurityInfo;